import { PostBox } from 'pages/home/Home.style';
import styled from 'styled-components';

const SettingsStyles = styled.div`
  width: 100%;
  display: flex;
  height: 90vh;
  color: ${({ theme }) => theme.text1};

  .setting-info-container {
    width: 100%;
  }
  .setting-title {
    font-size: 18px;
    font-weight: 600;
    padding: 16px 16px 8px;
    display: flex;
    align-items: center;
    .back-icon {
      margin-right: 10px;
    }
  }
  .setting-back {
    padding: 16px 8px 8px;
  }
  .mention-actions {
    padding-left: 16px;
    padding-top: 6px;
    .lebelView {
      label {
        font-size: 15px;
      }
    }
    .MuiFormGroup-root {
      margin-top: 14px;
      .MuiFormControlLabel-label {
        font-size: 16px;
        color: ${({ theme }) => theme.text1} !important;
        margin-left: 8px;
      }
      .radio-helperText {
        margin: 0 0 18px 32px;
      }
    }
  }
  .mention-advance-settings {
    margin-left: 16px;
  }
  .accept-request-label {
    display: flex;
    justify-content: space-between;
    margin-top: 4px;
    padding: 8px 8px 8px 16px;
    .setting-help-title {
      margin-bottom: 6px;
    }
  }
  .privacy-item {
    align-items: center;
    &:hover {
      cursor: pointer;
      background-color: ${({ theme }) => theme.lightGrayHover};
    }
  }
  .right-arrow {
    path {
      fill: ${({ theme }) => theme.svg1};
    }
  }
  .accept-request-helper {
    font-size: 13px;
    color: #828282;
  }
  ${PostBox} {
    display: flex;
    width: 100%;
    > div:first-child {
      width: 43%;
      border-right: 1px solid ${({ theme }) => theme.lightGray};
    }
    > div:nth-child(2) {
      width: 65%;
    }
    @media only screen and (max-width: 767px) {
      width: 98%;
      > div:first-child,
      > div:nth-child(2) {
        width: 100%;
        border-right: none;
        margin-right: 8px;
      }
    }
  }
  .setting-menu {
    font-size: 15px;
    cursor: pointer;
    border-radius: 2px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 16px;
    .right-arrow {
      text-align: end;
      display: flex;
      align-items: center;
      path {
        fill: ${({ theme }) => theme.svg1};
      }
    }
    &:hover {
      background-color: ${({ theme }) => theme.lightGrayHover};
    }
    &:last-child {
      color: #fc223b;
      svg path {
        fill: #fc223b;
      }
    }
    > div:nth-child(2) {
      display: flex;
      align-items: center;
      div {
        margin-right: 16px;
        width: 200px;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
        text-align: right;
      }
    }
  }
  .hide-account-item {
    display: none;
  }
  .active {
    background-color: ${({ theme }) => theme.lightGray};
  }
  .setbtn {
    margin-top: 20px;
    text-align: end;
    > button:first-child {
      margin-right: 10px;
    }
  }
  .inputbox {
    .inputContainer,
    .phoneInputContainer {
      margin-top: 16px;
    }
    /* temp */
    .setting-menu:nth-child(4) {
      display: none;
    }
  }
  .otp-resend {
    width: 100%;
    padding-top: 16px;
    display: flex;
    justify-content: center;
    span {
      margin-right: 8px;
    }
    div {
      min-width: 86px;
    }
    > a {
      cursor: pointer;
      font-weight: bold;
      color: #016edc;
    }
  }
  .account-type-container {
    .MuiFormGroup-root {
      display: flow;
      width: 100%;
    }
    .MuiFormControlLabel-label {
      color: ${({ theme }) => theme.text1} !important;
      font-size: 15px;
      margin-right: 16px;
    }
  }
  .add-emailPhone {
    color: #1976d2;
    font-weight: 600;
  }
  .setting-action-content {
    padding: 12px 16px 12px;
  }
`;

const MoreNavs = styled.div`
  position: relative;
  height: 80vh;
  .more-navs {
    color: ${({ theme }) => theme.text1};
    font-size: 15px;
    cursor: pointer;
    border-radius: 2px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px;
    .right-arrow {
      text-align: end;
      display: flex;
      align-items: center;
      path {
        fill: ${({ theme }) => theme.svg1};
      }
    }
    &:hover {
      background-color: ${({ theme }) => theme.lightGrayHover};
    }
    > div:nth-child(2) {
      display: flex;
      align-items: center;
      div {
        margin-right: 16px;
      }
    }
    .more-nav-label {
      display: flex;
      align-items: center;
      .start-icon {
        width: 22px;
        height: 22px;
        margin-right: 12px;
        fill: ${({ theme }) => theme.svg1};
      }
    }
  }
  .more-mobile-download {
    position: absolute;
    bottom: 0px;
    text-align: center;
    width: 100%;
    > div {
      display: grid;
      justify-content: center;
    }
  }
  .appstore-download-img {
    cursor: pointer;
    color: #000;
    margin-bottom: 30px;
    &:hover {
      color: #4c4c4c;
    }
  }
  .more-mobile-download-description {
    font-size: 14px;
    margin-bottom: 10px;
  }
`;

export { SettingsStyles, MoreNavs };
